import { render, staticRenderFns } from "./Imagem.vue?vue&type=template&id=44417cab&scoped=true"
import script from "./Imagem.vue?vue&type=script&lang=js"
export * from "./Imagem.vue?vue&type=script&lang=js"
import style0 from "./Imagem.vue?vue&type=style&index=0&id=44417cab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44417cab",
  null
  
)

export default component.exports